export default __webpack_public_path__ + "maps-examples-fly-to-960-7bc33d771c9fb0a9d8cb335e92add823.webp";